import React from 'react';

const Definition = () => {
  return (
    <div className="container">
      <h1 className="page-title">Definition and Research</h1>
      
      <div className="section">
        <h2>Theory of Solution-focused practice 2020</h2>
        <div style={{display: 'flex', gap: '2rem', alignItems: 'flex-start', flexWrap: 'wrap'}}>
          <div style={{flex: '1', minWidth: '300px'}}>
            <p><strong>The EBTA Book "Theory of Solution-Focused Practice" 2020 has been published!</strong></p>
            <p>We, the authors, are happy with this co-creative process of shaping the theoretical thoughts of the solution-focused practice in a creative, joyful and sometimes reiterative systematic way that lead to the carefully crafted 'co-knowing' formulations in the book. Also disputes and differences are visible together with the additional reviewer 'co-knowers' views. It has been like a piece of Jazz: constantly changing and developing, with many variations in an open-ended process that provides space for further developments.</p>
            <p>Now we are excited to see where it goes next!</p>
            
            <h3>Translations</h3>
            <p>The book has been translated into Dutch, Italian and Polish. Finnish, German and French translation are on the way.</p>
            
            <p><strong><a href="https://buchshop.bod.de/catalogsearch/result/?q=ebta" target="_blank" rel="noopener noreferrer" style={{color: '#2563eb'}}>Get your copy</a></strong></p>
          </div>
          <div style={{flexShrink: 0}}>
            <img 
              src={`${process.env.PUBLIC_URL}/images/boek.jpg`}
              alt="Theory of Solution-Focused Practice 2020 book cover"
              style={{
                maxWidth: '250px',
                width: '100%',
                height: 'auto',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
              }}
            />
          </div>
        </div>
      </div>

      <div className="section">
        <h2>Definition Solution Focused Brief Therapy</h2>
        <p>Solution Focused Brief Therapy (SFBT) is a therapeutic approach that looks at the present and the goals each person sets to improve his/her future.</p>
        
        <p>This approach was created by Steve de Shazer and the Brief Family Therapy Center in Milwaukee during the early 1980s. Among the concepts and tools that are the basis of the therapeutic intervention, we can remember the pre-session change technique, looking for exceptions to the problem, the enhancement of skills, the miracle question, the scaling questions and the tasks to be given between a session and the other one.</p>
        
        <p>De Shazer's SFBT adopts phenomenological and constructivist epistemology, which seeks to understand the meaning that people attribute to events and experiences.</p>
        
        <p>The therapist abandons the role of expert and avoids providing interpretations, which often contribute to define the "problem" in terms that make it even more difficult to solve. In fact, only clients can be recognized as true experts of themselves. Diagnostic evaluations are also restructured in order to highlight the strengths of people, in a constructivist perspective oriented towards change and solution.</p>
      </div>

      <div className="section">
        <h2>EBTA Task Group Definition (2020)</h2>
        <p>Different authors of the EBTA Task Group (2020) lately defined solution-focused practice with the aim to construct a Theory of Solution Focused Practice for those who want to understand the rationale, together with a comprehensive description of solution-focused practice that can be used for training and developmental purposes.</p>
        
        <p>The authors (Sundman a.o. 2020) defined theory as being a process theory. It is describing how the solution-focused practice is done, together with explanations of how and why the process is initiated, why it goes in a certain direction and who is responsible for it. In addition the rationale and assumptions that the theory is based on – and general predictions of the outcome – are also explicitly described.</p>
        
        <p>A general definition of solution-focused practice in the different practice contexts can be found on p.23:</p>
        
        <blockquote style={{
          borderLeft: '4px solid #2563eb',
          paddingLeft: '1rem',
          margin: '1.5rem 0',
          fontStyle: 'italic',
          backgroundColor: '#f8fafc',
          padding: '1rem'
        }}>
          "Clients get support for the change they hope for from a practitioner based on the clients' resources, skills, strengths, future hopes and interaction in their environment. For the clients it means formulating and applying new orientations to self, others and the future. This is thus a theory of how to support a client's change."
        </blockquote>
        
        <div style={{fontSize: '0.9rem', color: '#666', marginTop: '1rem'}}>
          <p>References:</p>
          <p>See also Miller &amp; McKergow (2012).</p>
          <p>Bavelas, J., Korman, H., DeJong, P., Smock, S. (2014).</p>
        </div>
      </div>
    </div>
  );
};

export default Definition;
